import {botRulesConstants} from "../constants/botRulesConstants";

const initialState = {
    rerender: false,
    botRules: null,
    isLoading: false,
};

const botRulesReducer = (state = initialState, action) => {
    switch (action.type) {
        case botRulesConstants.BOT_RULES_LOADING_SPINNER:
            return {
                ...state,
                isLoading: true,
            };
        case botRulesConstants.BOT_RULES_STOP_LOADING_SPINNER:
            return {
                ...state,
                isLoading: false,
            };
        case botRulesConstants.BOT_RULES_RERENDER:
            return {
                ...state,
                rerender: action.payload.rerender
            };
        case botRulesConstants.BOT_RULES_GET_DATA:
            return {
                ...state,
                botRules: action?.payload?.result?.botRules,
                isLoading: false,
                rerender: false
            };
        case botRulesConstants.BOT_RULES_VALIDATION_ERROR:
            return {
                ...state,
                errorMsg: action.payload.errorMessage
            };
        default:
            return state;
    }
};

export default botRulesReducer;